import Swal from 'sweetalert2';

export function toastSuccess(title, text, button) {
  Swal.fire({
    title: title,
    text: text,
    icon: 'success',
    confirmButtonText: button || 'OK',
  });
}

export function toastError(title, text, button) {
  Swal.fire({
    title: title,
    text: text,
    icon: 'error',
    confirmButtonText: button || 'OK',
  });
}
